<template>
  <donut-chart104-template
    :board-ids="[938, 940]"
    :data-type="dataType"
    :graph-id="104"
    :depth="depth"
    date-field="$.body.education_date"
    :is-move-detail="false"
    title="안전·보건 교육 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */

import DonutChart104Template from "@/views/graph/DonutChart104Template.vue";

export default {
  name: 'DonutChart104',
  components: {DonutChart104Template},
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
    dataType() {
      if (!this.projectId) {
        return 'project';
      }
      return 'educationType';
    },
    depth() {
      switch (this.getLevel) {
      case 1:
      case 2:
        return 1;
      case 3:
        return 1;
      case 4:
        return 0;
      default:
        return 1;
      }
    }
  }
}
</script>

<style scoped>

</style>
